import React from "react";
import { X, File, Image } from "lucide-react";

export const FileUpload = ({ files, onRemove }) => {
  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const renderFilePreview = (file, index) => {
    const isImage = file.type.startsWith("image/");
    const fileName = file.name.length > 20 ? file.name.substring(0, 20) + '...' : file.name;

    return (
      <div key={`${file.name}-${index}`} className="relative bg-white border border-gray-200 rounded-lg p-3 m-2 shadow-sm hover:shadow-md transition-shadow">
        <div className="flex items-center space-x-3">
          {isImage ? (
            <div className="flex-shrink-0">
              <img
                src={URL.createObjectURL(file)}
                alt={file.name}
                className="w-12 h-12 object-cover rounded-md"
              />
            </div>
          ) : (
            <div className="flex-shrink-0 w-12 h-12 bg-gray-100 rounded-md flex items-center justify-center">
              <File className="w-6 h-6 text-gray-500" />
            </div>
          )}
          
          <div className="flex-grow min-w-0">
            <p className="text-sm font-medium text-gray-900 truncate" title={file.name}>
              {fileName}
            </p>
            <p className="text-xs text-gray-500">
              {formatFileSize(file.size)}
            </p>
            {isImage && (
              <div className="flex items-center mt-1">
                <Image className="w-3 h-3 text-blue-500 mr-1" />
                <span className="text-xs text-blue-500">Image</span>
              </div>
            )}
          </div>
          
          <button
            onClick={() => onRemove(file)}
            className="flex-shrink-0 p-1 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full transition-colors"
            title="Remove file"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    );
  };

  if (files.length === 0) {
    return null;
  }

  return (
    <div className="mb-4">
      <div className="flex items-center justify-between mb-2">
        <h4 className="text-sm font-medium text-gray-700">
          Uploaded Files ({files.length})
        </h4>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {files.map(renderFilePreview)}
      </div>
    </div>
  );
};
